import { Navigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import Layout from "@/components/app/Layout";
import { useAuth } from "@/lib/auth";
import { useCachedGet } from "@/lib/cache";
import { isLicenseAdmin } from "@/components/app/license/licenseUtil";
import LicensesPanel from "@/components/app/license/LicensesPanel";
import OwnerSummary from "@/components/app/license/OwnerSummary";
import PlanUsage from "@/components/app/license/PlanUsage";
import ClientAllocations from "@/components/app/license/ClientAllocations";

export default function LicensesPage() {
  const { user } = useAuth();
  if (user && !isLicenseAdmin(user)) return <Navigate to="/app" replace />;
  const owner = user?.role === "platform_owner";
  return (
    <Layout>
      <div className="max-w-7xl mx-auto space-y-6" data-testid="licenses-page">
        <div>
          <h1 className="text-3xl font-display font-semibold text-slate-900 flex items-center gap-2">
            <KeyRound className="w-7 h-7 text-indigo-600" /> {owner ? "Licenses & Usage" : "Licenses"}
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            {owner ? "Plans, credits and interview usage across every workspace." : "Your plan, this month's interview usage and optional per-client allocation."}
          </p>
        </div>
        {owner ? <OwnerView /> : (<><PlanUsage /><ClientAllocations /></>)}
      </div>
    </Layout>
  );
}

function OwnerView() {
  const [data, reload] = useCachedGet("/admin/licenses");
  return (<><OwnerSummary data={data} /><LicensesPanel data={data} reload={reload} /></>);
}
